import Vue from 'vue'
import { dcb } from '@dcb/jssdk'
import { ImagePreview } from 'vant'
import { isUrl } from 'vtils'
import { LiteralUnion } from 'vtils/types'

export function useHandler<T extends string>(
  handlers: Record<T, (...args: any[]) => any>,
) {
  const handle = (urlOrType: LiteralUnion<T, string>, ...args: any[]) => {
    if (isUrl(urlOrType)) {
      dcb.navigateTo({
        url: urlOrType,
      })
      return
    }

    if ((handlers as any)[urlOrType]) {
      ;(handlers as any)[urlOrType](...args)
    }
  }
  handle.img = (url: string) =>
    ImagePreview({
      images: [url],
      startPosition: 0,
    })
  handle.res = Vue.prototype.$handleResourceClick
  handle.url = (url: string) => dcb.navigateTo({ url })
  return handle
}
